import { DossierGroupeActionProvider } from '@europrocurement/l2d-modules';
import React from 'react';
import { DossierGroupTable } from '../DossierGroupTable';
import { ModalDossierGroupAction } from '../ModalDossierGroupAction';

export const DossierGroupList: React.FunctionComponent = function () {
    return (
        <DossierGroupeActionProvider>
            <DossierGroupTable />
            <ModalDossierGroupAction />
        </DossierGroupeActionProvider>
    );
};
